import * as React from 'react';
import { clsx } from 'clsx';
import { TColors } from '@cian/ui-kit';

import * as styles from './IconNoCar16.css';

interface IIconNoCar16Props {
  color?: TColors;
}

// TODO: Заменить на китовую иконку в CD-170476
export const IconNoCar16: React.FC<IIconNoCar16Props> = ({ color }) => {
  return <div className={clsx(styles['icon'], color === 'white_100' && styles['white'])} />;
};
